export default (page) => {
  window.dataLayer.push({
    event: 'campaign_page',
    page,
  });
  return {
    type: 'CHANGE_COMPAIGN_PAGE',
    page,
  };
};



// WEBPACK FOOTER //
// ./src/Actions/Campaign/changePage.js